<template>
  <div id="LoggedIn" :class="'nav-' + navType">
    <div class="theme position-relative d-flex" ref="logged_in">
      <div class="main position-relative">
        <SideFeedbackButton />
        <div
          class="main-inner bg-white"
          :class="{
            'no-side-bar': !showSideBar,
            'limit-scroll': isOverlayVisible
          }"
        >
          <Header :isLightTheme="isLightTheme"></Header>
          <ContentRouter />
          <Footer :isLightTheme="isLightTheme"></Footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ContentRouter from "@/components/ContentRouter.vue";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import SideFeedbackButton from "../components/TMH/SideFeedbackButton.vue";
import EventBus from "@/helpers/eventbus";
import { mapState } from "vuex";
import { getServices, getNavigationTags } from "../../api";

export default {
  name: "LoggedIn",
  components: {
    Header,
    ContentRouter,
    Footer,
    SideFeedbackButton
  },
  data() {
    return {
      isLightTheme: false
    };
  },
  created() {
    let self = this;
    let closeFn = () => {
      self.$store.dispatch("logout", self.$route.path);
    };
    if (!this.$store.state.user.authenticated) {
      this.$store.dispatch("logout", self.$route.path);
      this.$router.push("/login").catch(err => {});
    } else {
      localStorage.setItem("previousRoute", self.$route.path);
      // window.addEventListener('beforeunload', closeFn);
    }
  },
  mounted() {
    // this.fetchOAuthParams();
    this.computeIsLightTheme();
    gtag("config", process.env.VUE_APP_GA_TRACKING_ID, {
      user_id: this.$store.getters.user.user.user_id
    });
    this.fetchNavigationTags();
    this.fetchServices();
  },
  onActive() {},
  onIdle() {
    this.$store.dispatch("logout");
    this.$router.push("/login").catch(err => {});
  },
  computed: {
    ...mapState(["isOverlayVisible"]),
    navType() {
      return this.$store?.getters?.navType;
    },
    theme() {
      let skin = this.$store.getters.client.skin;
      return "theme-" + skin;
    },
    showSideBar() {
      if (
        this.$store?.state?.accessCode ||
        this.$store?.getters?.subdomain.toLowerCase().includes("laya-wellbeing")
      ) {
        return false;
      } else return true;
    }
  },
  methods: {
    emitChallenges() {
      EventBus.$emit("getChallengesData");
    },
    scrollTo(coordinates) {
      this.$refs.logged_in.parentNode.scrollTop = coordinates;
    },
    getParameterFromURL(paramName) {
      const params = new URLSearchParams(window.location.search);
      return params.get(paramName);
    },
    computeIsLightTheme() {
      const path = this.$route.path;
      this.isLightTheme =
        path !== "/" &&
        !path.startsWith("/my-health-area/") &&
        !path.startsWith("/my-health-handover/");
    },
    async fetchServices() {
      try {
        const res = await getServices();
  
        if (res.status === 200 && res.data.success) {
          const services = res.data.my_health;
          this.$store.dispatch("updateServices", services);
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.$store.dispatch("updateServices", []);
        }
      } catch (err) {
        // console.error(err)
      }
    },
    async fetchNavigationTags() {
      try {
        const res = await getNavigationTags();
  
        if (res.data.success) {
          const navigationTags = res.data.data;
          this.$store.dispatch("updateNavigationTags", navigationTags);
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      } catch (err) {
        // console.error(err)
      }
    },
    async fetchOAuthParams() {
      let scope = this.getParameterFromURL("scope");
      let oAuthRedirectGoogle = {
        path: "api/u/oauth/google/redirect",
        code: this.getParameterFromURL("code"),
        scope: this.getParameterFromURL("scope")
      };

      if (!(oAuthRedirectGoogle.code && oAuthRedirectGoogle.scope)) {
        return;
      }

      try {
        let res = await this.api(oAuthRedirectGoogle);

        if (res.success) {
          if (scope.includes("fitness.activity.read")) {
            this.$router.push("/challenges");
          } else {
            this.$router.push("/");
          }
        } else {
          alert("Error occurred. Please try again.");
        }
      } catch (e) {
        console.log(e);
      }
    },
    getAllowedRoutes() {
      const nav = this.$store.getters.nav;
      let accessValues = {
        wellbeing_series_access: false,
        digital_gym_access: false,
        wellbeing_studio_access: false,
        wellbeing_benefits_access: false,
        my_organisation_access: false,
        eap_access: false,
        events_access: false,
        be_calm_access: false,
        plans_access: false
      };
      for (const [key, value] of Object.entries(accessValues)) {
        nav.forEach(function(navElement) {
          navElement.items.forEach(function(navItem) {
            //if the formatted nav values and access values match, set access value to true
            if (
              navItem.name
                .split(" ")
                .join("_")
                .toLowerCase() === key.replace("_access", "")
            ) {
              accessValues[key] = true;
            }
          });
        });
      }
      return accessValues;
    }
  },
  watch: {
    $store() {
      if (!this.$store.state.user.authenticated) {
        this.$router.push("login").catch(err => {});
      }
    },
    $route(newVal) {
      this.computeIsLightTheme();

      if (this.navType === "versionTwo") {
        document
          .getElementById("newNavTop")
          .scrollIntoView({ behavior: "smooth" });
      } else {
        this.scrollTo(0);
      }
      if (newVal.name === "challenges") {
        this.emitChallenges();
      }
    }
  }
};
</script>
<style lang="less">
@import "../assets/responsiveness";

.limit-scroll {
  max-height: 100vh;
  overflow: hidden;
}

.aside {
  width: 60px;
  max-width: 60px !important;
}

.main {
  .main-inner {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .content-container {
    max-width: 1160px;
    margin: auto;
  }

  .page-bg {
    width: 100%;
    padding-bottom: 30px;
  }

  .bg-white {
    background-color: #fff;
  }

  .bg-grey {
    background-color: #f7f7f7;
  }

  .bg-primary-dark {
    background-color: #3e1954;
  }

  .page-title {
    h2 {
      font-size: 3.8rem;
      letter-spacing: 0.7rem;
      font-family: "PlusJakartaSansBold";
    }
  }

  h3 {
    font-size: 2.3rem;
    font-family: "PlusJakartaSansBold";
    letter-spacing: 0.3rem;
    padding: 40px 0 30px 0;
  }

  h4 {
    font-family: "PlusJakartaSansBold";
    font-size: 1.7rem;
    margin-bottom: 30px;
  }

  .section-header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    flex-direction: row-reverse;

    &.section-header-right {
      flex-direction: row;

      .section-header-title {
        padding-right: 0;
        padding-left: 15px;
        text-transform: capitalize;
      }
    }

    .section-header-title {
      white-space: nowrap;
      padding-right: 10px;
    }

    .section-header-divider {
      height: 1px;
      background: #cdcdcd;
      width: 100%;
      transform: translateY(5px);
    }
  }
}

.pop-up-content {
  background: #fff;
  width: 100%;
  border-radius: 25px !important;
  padding: 30px 20px;
  font-family: "PlusJakartaSansRegular";
  font-size: 2rem;
  margin-bottom: 30px;
  text-align: center;
  z-index: 10;

  .modal-header {
    text-align: center;
    border-bottom: none;

    .modal-title {
      margin: auto;
      text-align: center;
      font-size: 3rem;
    }
  }

  .modal-footer {
    border-top: none;
    justify-content: center;

    .btn {
      border: none;
      border-radius: 60px;
      font-size: 2rem;
      line-height: 1;
      letter-spacing: 0.2rem;
      border-width: 0;
      padding: 10px 30px;
    }
  }
}

.nav-versionTwo {
  .main {
    width: 100% !important;
    display: inline-block !important;
    background-color: white;
  }

  #Home {
    background-color: white;
  }
}
</style>
